import React from "react";
import styled, { keyframes } from "styled-components";
import { useRef, useState, useEffect } from "react";

const fadeInRight = keyframes`
    from {
        opacity: 0;
        transform: translateX(40px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 3em 4vw;
    background: transparent;
    min-height: 340px;
    gap: 0.5em;
    overflow-x: hidden;
    @media (max-width: 1200px) and (min-width: 1058px) {
        display: grid;
        grid-template-columns: 1fr 1.2fr 1fr;
        grid-template-areas: "img txt contact";
        align-items: center;
        gap: 1.5em;
        min-height: 0;
        padding: 2em 2vw;
    }
    @media (max-width: 1200px) {
        gap: 0.2em;
    }
    @media (max-width: 900px) {
        flex-direction: column;
        align-items: stretch;
        min-height: 0;
        gap: 1.5em;
    }
`;

const ImgBox = styled.div`
    flex: 0 0 260px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 260px;
    min-width: 180px;
    @media (max-width: 1200px) and (min-width: 1058px) {
        grid-area: img;
        justify-content: flex-end;
        height: 200px;
    }
    @media (max-width: 900px) {
        justify-content: center;
        margin-bottom: 0.5em;
        height: 180px;
    }
        
`;

const Img = styled.img`
    width: 100%;
    max-width: 260px;
    height: auto;
    object-fit: contain;
    @media (max-width: 600px) {
  max-width: 200px;
}
`;

const TextBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.7em;
    margin-left: 2vw;
    transition: transform 2s cubic-bezier(.77,0,.18,1), opacity 2s;
    transform: ${({ moved }) => moved ? 'translateX(-18vw)' : 'translateX(0)'};
    opacity: ${({ moved }) => moved ? 0.7 : 1};
    z-index: 2;
    max-width: 480px;
    @media (max-width: 1200px) and (min-width: 1058px) {
        grid-area: txt;
        margin-left: 0;
        max-width: 100%;
        gap: 0.5em;
        transform: none !important;
        opacity: 1 !important;
    }
    @media (max-width: 1200px) {
        max-width: 340px;
        margin-left: 1vw;
        gap: 0.5em;
    }
    @media (max-width: 900px) {
        transform: none !important;
        opacity: 1 !important;
        margin-left: 0;
        max-width: 100%;
        gap: 1em;
    }
`;
const ContactBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    min-width: 260px;
    gap: 0.7em;
    opacity: ${({ show }) => show ? 1 : 0};
    transform: ${({ show }) => show ? 'translateX(0)' : 'translateX(18vw)'};
    transition: transform 2s cubic-bezier(.77,0,.18,1), opacity 2s;
    @media (max-width: 1200px) and (min-width: 1058px) {
        grid-area: contact;
        align-items: flex-start;
        min-width: 0;
        transform: none !important;
        opacity: ${({ show }) => show ? 1 : 0};
        gap: 0.5em;
    }
    @media (max-width: 900px) {
        align-items: center;
        min-width: 0;
        transform: none !important;
        opacity: ${({ show }) => show ? 1 : 0};
        gap: 1em;
    }
`;
const ContactTitle = styled.h4`
    font-size: 1.5em;
    color: #515151;
    font-weight: 700;
    margin: 0 0 0.5em 0;
    text-align: right;
`;

const ButtonRow = styled.div`
    display: flex;
    gap: 1em;
`;

const ContactButton = styled.a`
    display: flex;
    align-items: center;
    gap: 0.5em;
    background: #e53935;
    color: #fff;
    font-weight: 600;
    font-size: 1.1em;
    border: none;
    border-radius: 8px;
    padding: 0.7em 1.3em;
    text-decoration: none;
    box-shadow: 0 2px 8px rgba(229,57,53,0.08);
    transition: background 0.2s;
    cursor: pointer;
    &:hover {
        background: #b71c1c;
    }
`;

const Icon = styled.span`
    font-size: 1.3em;
`;

const Title = styled.h2`
    font-size: 3.8em;
    color: #000000ff;
    font-weight: 900;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin: 0;
    opacity: 0;
    animation: ${fadeInRight} 1s ease forwards;
    @media (max-width: 600px) {
  font-size: 2em;
  text-align: center;
}
`;

const SubTitle = styled.h3`
    font-size: 2em;
    color: #e53935;
    font-weight: 700;
    margin: 0;
    opacity: 0;
    animation: ${fadeInRight} 1.2s ease forwards;
    @media (max-width: 600px) {
  font-size: 1.5em;
  text-align: center;
}
`;

export const AvisaRetira = () => {
    const sectionRef = useRef();
    const [moved, setMoved] = useState(false);
    const [showContact, setShowContact] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (!sectionRef.current) return;
            const rect = sectionRef.current.getBoundingClientRect();
            const inView = rect.top < window.innerHeight && rect.bottom > 0;
            setMoved(inView);
            setShowContact(inView);
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <Container ref={sectionRef}>
            <ImgBox>
                <Img src={process.env.PUBLIC_URL + "/imagenes/caja.png"} alt="Retira sin demoras" />
            </ImgBox>
            <TextBox moved={moved}>
                <Title>RETIRA SIN DEMORAS!</Title>
                <SubTitle>SERVICIO EXPRESS</SubTitle>
            </TextBox>
            <ContactBox show={showContact}>
                <ContactTitle>SOLICITA TU AVISO DE RETIRA:</ContactTitle>
                <ButtonRow>
                    <ContactButton href="mailto:camila_bachini@solutionbox.com.ar" 
                                 aria-label="Contactar por email para solicitar aviso de retira">
                        <Icon>📧</Icon> Mail
                    </ContactButton>
                    <ContactButton href="https://wa.me/541124923222" target="_blank" rel="noopener noreferrer" 
                                 aria-label="Contactar por WhatsApp para solicitar aviso de retira - Abre en nueva ventana">
                        <Icon>💬</Icon> Whatsapp
                    </ContactButton>
                </ButtonRow>
            </ContactBox>
        </Container>
    );
};

export default AvisaRetira;
